//Archivo dedicado al menu de todos los imports de Intranet

//Imports relacionados a Intranet
//-----------Principal-----------
import CPlantilla from '@/components/Intranet/Comun/CPlantilla.vue'
import CHomeIntranet from '@/components/Intranet/Comun/Estructura/Home/CHome.vue'

//-----------Documentos-----------
import CDocumentos from '@/components/Intranet/Areas/CDocumentos.vue'

//-----------Edictos-----------
import CEdictos from '@/components/Intranet/Areas/Edictos/CEdictos.vue'

//-----------Edictos-----------
import CClinicas from '@/components/Intranet/Areas/CClinicas.vue'

//-----------Documentos-----------
import CConvocatorias from '@/components/Intranet/Areas/CConvocatorias.vue'

//-----------Presidencia-----------
import CPresidencia from '@/components/Intranet/Areas/Presidencia/CPresidencia.vue'

//-----------Presidencia-----------
import CComunicadosLista from '@/components/Intranet/Areas/CComunicadosLista.vue'

//Se crea la lista de los paths
const Intranet = [
  { 
    name: 'Intranet', 
    path: '/Intranet/', 
    component: CPlantilla, 
    meta: { tituloDeLaPagina: "Intranet", 
    RequiereAutenticacion: true, 
    ValidaSesion: true, 
    ObtenDatos: true, 
    ObtenPermisosDelSistema: true, 
    SistemaQueSeIngreso: 33 }, 
    children: [ 
      /* HOME DE INTRANET */
      { 
        name: 'Inicio', 
        path: 'Inicio', 
        component: CHomeIntranet, 
        meta: { 
          tituloDeLaPagina: "Inicio", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 33
        } 
      },
      /* PAGINA DOCUMENTOS DE AREA */
      { 
        name: 'DocumentosArea', 
        path: 'Documentos/:url/:tipoDocumento', 
        component: CDocumentos, 
        meta: { 
          tituloDeLaPagina: "Documentos", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 33
        } 
      },
       /* PAGINA ENVIO DE EDICTOS */
      { 
        name: 'EnvioDeEdictos', 
        path: 'Edictos/Envio/:descripcion', 
        component: CEdictos, 
        meta: { 
          tituloDeLaPagina: "Envió de edictos", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 33
        } 
      },
      /* PAGINA CONVOCATORIAS */
      { 
        name: 'Clinicas', 
        path: 'Clinicas/:clinica', 
        component: CClinicas, 
        meta: { 
          tituloDeLaPagina: "Clinicas", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 33
        } 
      },
       /* PAGINA CONVOCATORIAS */
       { 
        name: 'Convocatorias', 
        path: 'Convocatorias/:convocatoria', 
        component: CConvocatorias, 
        meta: { 
          tituloDeLaPagina: "Convocatorias", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 33
        } 
      },
      /* PAGINA PRESIDENCIA */
      { 
        name: 'Presidencia', 
        path: 'Presidencia/Comunicados/:presidencia', 
        component: CPresidencia, 
        meta: { 
          tituloDeLaPagina: "Comunicados de presidencia", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 33
        } 
      },
      { 
        name: 'Comunicados', 
        path: 'Inicio/Noticias', 
        component: CComunicadosLista, 
        meta: { 
          tituloDeLaPagina: "Comunicados", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 33
        } 
      }
    ] 
  }
]

//Se regresa la lista de los paths
export default Intranet;



// WEBPACK FOOTER //
// ./src/router/Intranet.js